import React from 'react';
// import { DNA } from 'react-loader-spinner';

export default function Loader() {
  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "150px" }}>
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}

